import React, { useEffect, useState } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus.js';
import { getCachedImageUrl } from '../utils/offlineCache.js';

// Renders a card's attached image. Online, it's just the remote Storage URL (fast,
// no IndexedDB round-trip needed). Offline, resolves the cached blob instead — if it
// was never cached (this card was never viewed online), fails quietly rather than
// showing a broken-image icon.
const CardImage = ({ imageUrl, alt, className }) => {
    const isOnline = useOnlineStatus();
    const [offlineSrc, setOfflineSrc] = useState(null);

    useEffect(() => {
        if (isOnline || !imageUrl) { setOfflineSrc(null); return; }
        let cancelled = false;
        let objectUrl = null;
        getCachedImageUrl(imageUrl).then((url) => {
            if (cancelled) return;
            objectUrl = url;
            setOfflineSrc(url);
        });
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [isOnline, imageUrl]);

    if (!imageUrl) return null;
    if (!isOnline && !offlineSrc) return null;

    return <img src={isOnline ? imageUrl : offlineSrc} alt={alt} className={className} />;
};

export default CardImage;
